var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "archives-list-empty" }, [
    _c("img", { attrs: { src: "/static/img/empty-filter-result.png" } }),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.noResultFound")))]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.checkYourFilterCombination")))]),
    _vm._v(" "),
    _c("div", [
      _vm._v("\n        " + _vm._s(_vm.$t("chatbotv2.or")) + "\n        "),
      _c("span", { staticClass: "link", on: { click: _vm.clearFilters } }, [
        _vm._v(" " + _vm._s(_vm.$t("chatbotv2.clearYourSearch"))),
      ]),
      _vm._v("\n        " + _vm._s(_vm.$t("chatbotv2.andTryAgain")) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }